import dayjs from "dayjs";
import type { Dayjs, ConfigType, ManipulateType } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import localizedFormat from "dayjs/plugin/localizedFormat";
import isBetween from "dayjs/plugin/isBetween";
import isToday from "dayjs/plugin/isToday";
import isTomorrow from "dayjs/plugin/isTomorrow";
import isYesterday from "dayjs/plugin/isYesterday";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import relativeTime from "dayjs/plugin/relativeTime";
import customParseFormat from "dayjs/plugin/customParseFormat";
import weekOfYear from "dayjs/plugin/weekOfYear";
import duration from "dayjs/plugin/duration";
import calendar from "dayjs/plugin/calendar";

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.extend(isBetween);
dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.extend(isYesterday);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(weekOfYear);
dayjs.extend(duration);
dayjs.extend(calendar);

/**
 * Datetime contains all the methods and properties of a datetime instance, allowing for date manipulation, formatting, and comparison in a consistent manner across the application.
 */
export type Datetime = Dayjs;
/**
 * DatetimeInput represents the various formats that can be used to create a datetime instance, including strings, numbers, Date objects.
 */
export type DatetimeInput = ConfigType;
/**
 * DatetimeUnits defines the units of time that can be manipulated (e.g., day, week, quarter, month, year) when performing date calculations or formatting.
 */
export type DatetimeUnits = ManipulateType;
/**
 * DatetimeCalendarSpec defines the structure for custom calendar formatting options, allowing for flexible date display based on context (e.g., same day, next day, last week).
 */
export interface DatetimeCalendarSpec {
  sameDay?: string;
  nextDay?: string;
  nextWeek?: string;
  lastDay?: string;
  lastWeek?: string;
  sameElse?: string;
}

/**
 * datetime instance uses dayjs as base API
 */
const datetime = dayjs;
export default datetime;
